module.exports = __webpack_public_path__ + "img/logo-feelgoodplus-tagline-english.32c97032.svg";